import { useEffect, useRef, useState } from 'react';
import { ReactComponent as BellSvg } from '../../assets/svg/bell.svg';
import Dialog from './dialog';
import request from '../../lib/request';

const Notification = ({ currentNav, handleCurrentNav }) => {
  const dialogRef = useRef(null);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [notification, setNotification] = useState({});

  useEffect(() => {
    getNotification({ next: false });
  }, [currentNav]);

  const getNotification = async ({ next = false }) => {
    try {
      let path = '/notification';

      if (next) {
        const {
          total: { count, page, perPage },
        } = notification;

        if (count < page * perPage) {
          return;
        }

        path += `?page=${page + 1}&perPage=${perPage}`;
      }

      const { result } = await request.get(path);

      if (result?.list) {
        setNotification((prev) => ({
          list: next ? prev.list?.concat(result.list) : result.list,
          unreadCount: result.unreadCount,
          total: result.total,
        }));
      }
    } catch (error) {
      console.error('Error fetching notification:', error);
    }
  };

  const openDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
      setIsDialogOpen(true);
    }
  };

  const closeDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
      setIsDialogOpen(false);
    }
  };

  return (
    <div className='absolute top-6 right-7'>
      {notification.unreadCount > 0 && (
        <span className='absolute top-[-3px] right-0'>
          <span className='relative flex h-2 w-2'>
            <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75'></span>
            <span className='relative inline-flex rounded-full h-2 w-2 bg-red-500'></span>
          </span>
        </span>
      )}
      <BellSvg
        className='size-5 cursor-pointer'
        onClick={openDialog}
        fill='white'
      />
      <Dialog
        dialogRef={dialogRef}
        closeDialog={closeDialog}
        isDialogOpen={isDialogOpen}
        notification={notification}
        currentNav={currentNav}
        handleCurrentNav={handleCurrentNav}
        getNotification={getNotification}
      />
    </div>
  );
};

export default Notification;
